import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class IndexedDBService {
    private _dbName = 'db_cmxgo';
    private _dbVersion = 1;

    private initDBCash(): Observable<any> {
        return Observable.create((observer: any) => {
            if (!('indexedDB' in window)) {
                observer.error('This browser does not support IndexedDB');
            }
            // Open/create database db_cmxgo version 1
            const openDBRequest = indexedDB.open(this._dbName, this._dbVersion);
            openDBRequest.onupgradeneeded = function() {
                const db = openDBRequest.result;
                // Validate exist cash table in db_cmxgo, if not exists create table cash
                if (!db.objectStoreNames.contains('cash')) {
                    db.createObjectStore('cash', { keyPath: 'userId' });
                }
            };
            openDBRequest.onsuccess = function() {
                observer.next(openDBRequest.result);
            };
            openDBRequest.onerror = function() {
                observer.error('IndexedDB is opened failed: ' + openDBRequest.error);
            };
        });
    }

    public addItemCash(data, userId): Observable<any> {
        return Observable.create((observer: any) => {
          const json = {
            userId: userId,
            data: data,
            updated: new Date(),
          };
          this.getItemDBCash(userId).subscribe(
            (responseGet: any) => {
              this.initDBCash().subscribe(
                (responseDB: any) => {
                  const db = responseDB;
                  const transaction = db.transaction('cash', 'readwrite');
                  const cashStore = transaction.objectStore('cash');
                  let requestSave;
                  // If exists userId to save, is update else add
                  if (responseGet) {
                    requestSave = cashStore.put(json);
                  } else {
                    requestSave = cashStore.add(json);
                  }
                  requestSave.onsuccess = function() {
                    console.log(requestSave.result);
                  };
                  requestSave.onerror = function() {
                    observer.error('CashSave is failed: ' + requestSave.error);
                  };
                  transaction.oncomplete = function() {
                    db.close();
                    observer.next(requestSave.result);
                  };
                },
                (error: string) => {
                  observer.error(error);
                },
              );
            },
            (error: string) => {
              observer.error(error);
            },
          );
        });
    }

    public deleteItemCash(userId): Observable<any> {
        return Observable.create((observer: any) => {
            this.initDBCash().subscribe(
                (responseDB: any) => {
                    const db = responseDB;
                    const transaction = db.transaction('cash', 'readwrite');
                    const cashStore = transaction.objectStore('cash');
                    const requestDelete = cashStore.delete(userId);
                    requestDelete.onsuccess = function() {
                        console.log(requestDelete.result);
                    };
                    requestDelete.onerror = function() {
                        observer.error('CashSave is failed: ' + requestDelete.error);
                    };
                    transaction.oncomplete = function() {
                        db.close();
                        observer.next(requestDelete.result);
                    };
                },
                (error: string) => {
                    observer.error(error);
                },
            );
        });
    }

    public getItemDBCash(userId): Observable<any> {
        return Observable.create((observer: any) => {
            this.initDBCash().subscribe(
                (response: any) => {
                    const db = response;
                    const requestGet = db.transaction(['cash'], 'readonly')
                        .objectStore('cash')
                        .get(userId);
                    requestGet.onsuccess = function() {
                        db.close();
                        observer.next(requestGet.result);
                    };
                    requestGet.onerror = function() {
                        observer.error('CashGet is failed: ' + requestGet.error);
                    };
                },
                (error: string) => {
                    observer.error(error);
                },
            );
        });
    }
}
